/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
// import { GoogleMap, Marker, useLoadScript } from '@react-google-maps/api';
import { makeStyles, Typography } from '@material-ui/core';

// inlining the image data so we don't have to host it anywhere and/or add another config
// const CUSTOM_STAPLES_MARKER =
// 'data:image/png;base64,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';
/** A basic google map which centers on a single marker */
// const NonInteractiveMap = ({ center, mapHeight, withBorderRadius }: any) => {
//   if (!process.env.REACT_APP_PUBLIC_GOOGLE_API_KEY) {
//     return <Typography>Could not load Google API key</Typography>;
//   }
//   if (!process.env.REACT_APP_PUBLIC_GOOGLE_MAP_ID) {
//     return <Typography>Could not load Google Map ID</Typography>;
//   }
//   const { isLoaded, loadError } = useLoadScript({
//     googleMapsApiKey: process.env.REACT_APP_PUBLIC_GOOGLE_API_KEY,
//     id: process.env.REACT_APP_PUBLIC_GOOGLE_MAP_ID,
//   });
//   if (loadError) {
//     return <Typography>Could not load map: {loadError}</Typography>;
//   }
//   if (!isLoaded) {
//     return null;
//   }
//   return (
//     <GoogleMap
//       mapContainerStyle={{
//         width: '100%',
//         height: mapHeight,
//         borderTopRightRadius: withBorderRadius ? '15px' : undefined,
//         borderTopLeftRadius: withBorderRadius ? '15px' : undefined,
//       }}
//       center={center}
//       zoom={15}
//       options={
//         {
//           mapId: process.env.REACT_APP_PUBLIC_GOOGLE_MAP_ID,
//           streetViewControl: false,
//           scaleControl: false,
//           mapTypeControl: false,
//           panControl: false,
//           zoomControl: false,
//           rotateControl: false,
//           fullscreenControl: false,
//           disableDefaultUI: true,
//           scrollwheel: false,
//           draggable: false,
//           disableDoubleClickZoom: true,
//         } as any
//       }
//     >
//       <Marker
//         position={center}
//         icon={{
//           url: CUSTOM_STAPLES_MARKER,
//         }}
//       />
//     </GoogleMap>
//   );
// };
const NonInteractiveMap = ({ center, mapHeight, withBorderRadius }: any) => {
  if (!process.env.REACT_APP_PUBLIC_GOOGLE_API_KEY) {
    return <Typography>Could not load Google API key</Typography>;
  }
  const parsedCenter = `${center.lat},${center.lng}`;
  const mapsStaticApi = `https://maps.googleapis.com/maps/api/staticmap?center=${parsedCenter}&zoom=15&size=400x${160}&markers=icon:${
    process.env.REACT_APP_MAP_CUSTOM_ICON
  }|${parsedCenter}&key=${process.env.REACT_APP_PUBLIC_GOOGLE_API_KEY}`;

  return (
    <div
      style={{
        width: '100%',
        height: mapHeight,
        borderTopRightRadius: withBorderRadius ? '15px' : undefined,
        borderTopLeftRadius: withBorderRadius ? '15px' : undefined,
        backgroundImage: `url(${mapsStaticApi})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }}
    />
  );
};

type MapPreviewProps = {
  id?: string;
  mapHeight: number;
  withBorderRadius?: boolean;
  center: { latitude: number | string; longitude: number | string };
  /** class styles are handled by the parent component for efficiency */
  className?: string;
};

// maybe pick a better default lat/long than the middle of the atlantic ocean
const DEFAULT_CENTER = {
  lat: 0,
  lng: 0,
};

/**
 * A non-interactive map displaying one location.
 * Used for previewing store locations.
 */
export function MapPreview({
  id,
  center,
  className,
  mapHeight,
  withBorderRadius,
}: MapPreviewProps) {
  // using div instead of Box for efficiency
  // and to avoid cascading style collisions
  const [numericCenter, setNumericCenter] = useState<{
    lat: number;
    lng: number;
  }>(DEFAULT_CENTER);
  useEffect(() => {
    const safeCenter = { lat: numericCenter.lat, lng: numericCenter.lng };
    if (typeof center.latitude === 'string') {
      safeCenter.lat = Number.parseFloat(center.latitude);
    } else if (typeof center.latitude === 'number') {
      safeCenter.lat = center.latitude;
    }
    if (typeof center.longitude === 'string') {
      safeCenter.lng = Number.parseFloat(center.longitude);
    } else if (typeof center.longitude === 'number') {
      safeCenter.lng = center.longitude;
    }
    setNumericCenter(safeCenter);
  }, [center]);

  return (
    <div className={className} id={id}>
      <NonInteractiveMap
        center={numericCenter}
        mapHeight={mapHeight}
        withBorderRadius={withBorderRadius}
      />
    </div>
  );
}

/** memoized for efficiency */
const MemoizedMapPreview = React.memo(MapPreview);

const withGradientSyles = makeStyles({
  overlay: {
    width: '100%',
  },
});

/**
 * A common effect we make to the map previews is add a white gradient over them.
 *
 * This overlay provides that gradient
 */
export function MapOverlay({ children }: any) {
  const classes = withGradientSyles();
  return <div className={classes.overlay}>{children}</div>;
}

export default MemoizedMapPreview;
